import type { SVGProps } from 'react';
export const SvgDislikeBtn = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#101010"
			strokeMiterlimit={10}
			d="m13.767 4.709-2.584-2c-.333-.334-1.083-.5-1.583-.5H6.433c-1 0-2.083.75-2.333 1.75l-2 6.083c-.417 1.167.333 2.167 1.583 2.167h3.334c.5 0 .916.416.833 1l-.417 2.666c-.166.75.334 1.584 1.084 1.834.666.25 1.5-.084 1.833-.584l3.417-5.083"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M18.017 4.708v8.167c0 1.167-.5 1.583-1.667 1.583h-.833c-1.167 0-1.667-.416-1.667-1.583V4.708c0-1.166.5-1.583 1.667-1.583h.833c1.167 0 1.667.417 1.667 1.583"
		/>
	</svg>
);
